import {
  GuidanceAction as SharedGuidanceAction,
  GuidanceActionStatus,
  GuidanceActionType,
  ALL_GUIDANCE_ACTION_STATUSES,
  ALL_GUIDANCE_ACTION_TYPES,
  GUIDANCE_ACTION_STATUSES,
  GUIDANCE_ACTION_TYPES,
} from "shared/dist/types/GuidanceAction";

export type { GuidanceActionStatus, GuidanceActionType };
export { ALL_GUIDANCE_ACTION_STATUSES, ALL_GUIDANCE_ACTION_TYPES, GUIDANCE_ACTION_STATUSES, GUIDANCE_ACTION_TYPES };

export default interface GuidanceAction extends SharedGuidanceAction {}

export interface GuidanceActionDefaults {
  title: string;
  description: string;
  ctaLabel: string;
  ctaPath: (context?: Record<string, string>) => string;
}

export const GUIDANCE_ACTION_DEFAULTS: Record<GuidanceActionType, GuidanceActionDefaults> = {
  [GUIDANCE_ACTION_TYPES.TEAM_MANAGER_SETUP_ROSTER]: {
    title: 'Set up your team roster',
    description: 'Add players to your team so they can sign up for events and compete together.',
    ctaLabel: 'Go to team roster',
    ctaPath: (ctx) => ctx?.orgId && ctx?.teamId ? `/team/${ctx.orgId}/${ctx.teamId}` : '/',
  },
};
